// extracted by mini-css-extract-plugin
export default {"selector":"SelectCompt_selector__LRMMY","payment_method":"SelectCompt_payment_method__ECqL3","payment_method_wrapp":"SelectCompt_payment_method_wrapp__zZ0qs"};